(function () {
  if (!customElements.get('video-player')) {

    class VideoPlayer extends HTMLElement {
      constructor() {
        super();
        this.videos = this.querySelectorAll('video');
        this.videoWeb = this.videos[0];
        this.videoMob = this.videos[1];
        this.playBtn = this.querySelector('.play-btn');
        this.soundBtn = this.querySelector('.mute-btn');
        this.disableClick = this.dataset.click;
      }

      connectedCallback() {
        this.initAccessibility();
        if (this.disableClick) {
          this.initEventListeners();
        }
      }

      initAccessibility() {
        const transcript = this.querySelector(".video-transcript");

        this.videos.forEach((video, index) => {

          if (transcript) {
            let transcriptId = transcript.id;
            if (!transcriptId) {
              transcriptId = `video-transcript-${Math.random().toString(36).substr(2, 9)}`;
              transcript.id = transcriptId;
            }
            video.setAttribute("aria-describedby", transcriptId);
          }

          const altText =
            video.getAttribute("alt") ||
            video.getAttribute("aria-label") ||
            "Video with transcript available.";

          video.setAttribute("aria-label", altText);
          video.setAttribute("alt", altText);

          if (!video.hasAttribute("tabindex")) {
            video.setAttribute("tabindex", "0");
          }
        });
      }

      initEventListeners() {
        this.videos.forEach(video => {
          video.addEventListener('click', () => this.togglePlay(video));
          video.addEventListener('ended', () => this.handleVideoEnded(video));
        });

        if (this.playBtn) {
          this.playBtn.addEventListener('click', () => this.handlePlayButton());
        }

        if (this.soundBtn) {
          this.soundBtn.addEventListener('click', () => this.toggleMute());
        }

        window.addEventListener('resize', () => this.handleResize());
      }
      
      togglePlay(video) {
        video.paused ? this.playVideo(video) : this.pauseVideo(video);
      }

      playVideo(video) {
        this.videos.forEach(otherVideo => {
          if (otherVideo !== video) {
            otherVideo.pause();
            otherVideo.muted = true;
          }
        });

        video.muted = false;
        video.play();
        this.classList.add('played');

        if (this.playBtn) {
          this.playBtn.style.opacity = '0';
          this.playBtn.style.pointerEvents = 'none';
        }

        if (this.soundBtn) {
          this.soundBtn.classList.remove('active');
        }
      }

      pauseVideo(video) {
        video.pause();
        video.muted = true;
        this.classList.remove('played');

        if (this.playBtn) {
          this.playBtn.style.opacity = '1';
          this.playBtn.style.pointerEvents = 'auto';
        }

        if (this.soundBtn) {
          this.soundBtn.classList.add('active');
        }
      }

      pauseAllVideo() {
        this.videos.forEach(video => this.pauseVideo(video));
      }

      handlePlayButton() {
        const targetVideo =
          window.innerWidth < 749 && this.videoMob
            ? this.videoMob
            : this.videoWeb;

        if (targetVideo) this.togglePlay(targetVideo);
      }

      toggleMute() {
        const targetVideo =
          window.innerWidth < 749 && this.videoMob
            ? this.videoMob
            : this.videoWeb;

        if (targetVideo) {
          targetVideo.muted = !targetVideo.muted;
          this.soundBtn.classList.toggle('active', targetVideo.muted);
        }
      }

      handleResize() {
        if (!this.videoMob) return;

        const isMobile = window.innerWidth < 749;
        const targetVideo = isMobile ? this.videoMob : this.videoWeb;

        this.videos.forEach(video => {
          video.pause();
          video.muted = true;
        });

        targetVideo.play();
        targetVideo.muted = false;
        targetVideo.pause();
      }

      handleVideoEnded(video) {
        if (!video.loop) {
          this.classList.remove('played');
          video.muted = true;

          if (this.playBtn) {
            this.playBtn.style.opacity = '1';
            this.playBtn.style.pointerEvents = 'auto';
          }
        }
      }
    }

    customElements.define('video-player', VideoPlayer);
  }
})();